<div class="psychologist-booking">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h5 class="fw-semibold m-0">Prenota appuntamento psicologo</h5>
    <span class="text-muted small">
      Prenota una seduta al posto del cliente
    </span>
  </div>

  <!-- Dettagli seduta da applicare alla prenotazione -->
  <div class="row g-3 align-items-end mb-3 p-2 border rounded bg-light">
    <div class="col-auto">
      <label class="form-label fw-bold mb-1" for="bookingSessionAmount">Importo seduta</label>
      <input
        type="number"
        id="bookingSessionAmount"
        class="form-control"
        [min]="0"
        [(ngModel)]="bookingSessionAmount"
        name="bookingSessionAmount"
      />
    </div>
    <div class="col-auto">
      <div class="form-check">
        <input
          type="checkbox"
          class="form-check-input"
          id="bookingDiscounted"
          [(ngModel)]="bookingDiscounted"
          name="bookingDiscounted"
        />
        <label class="form-check-label fw-bold" for="bookingDiscounted">Scontato</label>
      </div>
    </div>
  </div>

  <!-- Nessuno psicologo trovato -->
  <div
    *ngIf="psychologists.length === 0"
    class="alert alert-light border text-center"
  >
    Nessuno psicologo disponibile per i criteri di questa richiesta.
  </div>

  <!-- Lista psicologi -->
  <div class="row g-3">
    <div
      *ngFor="let psychologist of psychologists"
      class="col-12 col-md-6 col-xl-4"
    >
      <div class="card h-100" [class.border-primary]="isAssigned(psychologist)">
        <div class="card-body d-flex flex-column">
          <div class="d-flex align-items-center gap-2 mb-2">
            <img
              *ngIf="psychologist.info.photo"
              [src]="psychologist.info.photo"
              alt="foto"
              class="psychologist-avatar"
            />
            <div
              *ngIf="!psychologist.info.photo"
              class="psychologist-avatar psychologist-avatar--placeholder"
            >
              {{ psychologist.info.name.charAt(0)
              }}{{ psychologist.info.surname.charAt(0) }}
            </div>
            <div>
              <div class="fw-semibold">
                {{ psychologist.info.name }} {{ psychologist.info.surname }}
              </div>
              <span
                *ngIf="isAssigned(psychologist)"
                class="badge bg-primary"
              >
                Assegnato
              </span>
            </div>
          </div>

          <div
            *ngIf="psychologist.specialties.length"
            class="mb-2 d-flex flex-wrap gap-1"
          >
            <span
              *ngFor="let specialty of psychologist.specialties"
              class="badge bg-light text-dark border"
            >
              {{ specialty }}
            </span>
          </div>

          <!-- <p
            *ngIf="psychologist.info.description"
            class="text-muted small flex-grow-1 mb-3"
          >
            {{ psychologist.info.description }}
          </p> -->

          <button
            type="button"
            class="btn btn-primary mt-auto"
            [disabled]="loading || !psychologist.info.calendarLink"
            (click)="openCalendly(psychologist)"
          >
            <span
              *ngIf="loading"
              class="spinner-border spinner-border-sm me-1"
            ></span>
            {{
              psychologist.info.calendarLink
                ? 'Prenota appuntamento'
                : 'Calendario non disponibile'
            }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modale Calendly -->
  <app-calendly-modal
    *ngIf="showCalendlyModal"
    [caregiver]="selectedPsychologist"
    [isOpen]="showCalendlyModal"
    (close)="closeCalendly()"
    (scheduled)="onScheduled()"
  ></app-calendly-modal>
</div>
